import { Grid, TextField } from '@material-ui/core';
import { format } from 'date-fns';
import i18n from 'i18n';
import { AdvisorDetailsProps } from 'modules/advisors/interfaces';
import React from 'react';

interface AdvisorStatusInfoProps {
  advisorDetails: AdvisorDetailsProps;
}
const AdvisorStatusInfo = ({ advisorDetails }: AdvisorStatusInfoProps) => {
  const getAppliedBy = () => {
    if (advisorDetails?.applied_automatically) {
      return i18n.t('AUTOSKY_SYSTEM_KEY');
    }

    return `${advisorDetails?.applied_by?.first_name} ${advisorDetails?.applied_by?.last_name}`;
  };
  if (advisorDetails.status === 'ignored') {
    return (
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            type="onlyRead"
            label={i18n.t('IGNORED_BY_KEY')}
            variant="filled"
            value={`${advisorDetails?.ignored_by?.first_name} ${advisorDetails?.ignored_by?.last_name}`}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            type="onlyRead"
            label={i18n.t('IGNORED_AT_KEY')}
            variant="filled"
            value={format(
              new Date(advisorDetails?.ignored_at),
              'dd/MM/yyyy HH:mm'
            )}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            type="onlyRead"
            label={i18n.t('MESSAGE_KEY')}
            variant="filled"
            value={advisorDetails?.ignored_reason}
            multiline
            fullWidth
          />
        </Grid>
      </Grid>
    );
  }

  if (advisorDetails.status === 'applied') {
    return (
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            type="onlyRead"
            label={i18n.t('APPLIED_BY_KEY')}
            variant="filled"
            value={getAppliedBy()}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            type="onlyRead"
            label={i18n.t('APPLIED_AT_KEY')}
            variant="filled"
            value={format(
              new Date(advisorDetails?.applied_at),
              'dd/MM/yyyy HH:mm'
            )}
            fullWidth
          />
        </Grid>
      </Grid>
    );
  }

  if (advisorDetails.status === 'reverted') {
    return (
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            type="onlyRead"
            label={i18n.t('APPLIED_BY_KEY')}
            variant="filled"
            value={getAppliedBy()}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            type="onlyRead"
            label={i18n.t('APPLIED_AT_KEY')}
            variant="filled"
            value={format(
              new Date(advisorDetails?.applied_at),
              'dd/MM/yyyy HH:mm'
            )}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            type="onlyRead"
            label={i18n.t('REVERTED_BY_KEY')}
            variant="filled"
            value={`${advisorDetails?.reverted_by?.first_name} ${advisorDetails?.reverted_by?.last_name}`}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            type="onlyRead"
            label={i18n.t('REVERTED_AT_KEY')}
            variant="filled"
            value={format(
              new Date(advisorDetails?.reverted_at),
              'dd/MM/yyyy HH:mm'
            )}
            fullWidth
          />
        </Grid>
      </Grid>
    );
  }

  return <></>;
};

export default AdvisorStatusInfo;
